import React from "react";
import {
  GoogleMap,
  Marker,
  MarkerClusterer,
  useJsApiLoader
} from "@react-google-maps/api";


let GoogleMapsDashboard = ({ setCenter, zoom, locations }) => {
  const [map, setMap] = React.useState(null)

  const totalAmount = locations?.reduce((total, item) => total + (item?.amount || 0), 0) ?? 1;
  const colorBalancer = totalAmount / (locations?.length && locations?.length > 0 ? locations?.length : 1);

  function createKey() {
    return Math.random();
  }

  function handleZoomChange() {
    if (setCenter) {
      setCenter({
        lat: map?.center?.lat(),
        lng: map?.center?.lng()
      })
    }
  }

  const lightThemeStyle = [
    {
      featureType: "poi",
      elementType: "labels.text",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "poi.business",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "road",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "transit",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }
  ];

  const brazilCoordinates = {
    lat: -14.2400732,
    lng: -53.1805017
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  });

  return (
    isLoaded && (
      <div style={{ display: "flex", width: "100%", height: "600px" }}>
        <GoogleMap
          mapContainerStyle={{
            width: "100%",
            height: "100%"
          }}
          zoom={zoom}
          options={{
            styles: lightThemeStyle
          }}
          center={brazilCoordinates}
          onZoomChanged={handleZoomChange}
          onLoad={(map) => setMap(map)}
        >
          <MarkerClusterer
            minimumClusterSize={1}
            calculator={(markers) => {
              const sumAmount = markers.reduce((sum, marker) => {
                return sum + parseInt(marker.getLabel() || "0");
              }, 0);

              return {
                text: sumAmount.toString(),
                index: Math.min(Math.floor(sumAmount / colorBalancer), 5),
              };
            }}
          >
            {(clusterer) =>
              locations.map((location) => (
                <Marker
                  key={createKey()}
                  position={location}
                  clusterer={clusterer}
                  label={location.amount.toString()}
                />
              ))
            }
          </MarkerClusterer>
        </GoogleMap>
      </div>
    )
  );
};

GoogleMapsDashboard = React.memo(GoogleMapsDashboard);

export { GoogleMapsDashboard };
